const HeadingPrimary = () => {
   return (
     <h1 className="heading-primary">
       <span className="heading-primary--main">سکوی خدمات شهروندان</span>
       <span className="heading-primary--sub">(در شرایط بحران های سلامت)</span>
     </h1>
   );
}

export default HeadingPrimary;